/*
 * Sticky header stack — publishes two measurements as CSS variables.
 *
 *   --usp-bar-h       height of the USP bar. The bar and the header are sibling
 *                     sections, both sticky, so the header is offset downwards
 *                     by exactly this (see usp-bar.css).
 *   --sticky-stack-h  where the sticky stack currently ends: the lowest bottom
 *                     edge of the USP bar and the header. The PLP's Filter and
 *                     Sort bar sticks at this value.
 *
 * Hand-written values cannot stay correct: the heights move with the theme's
 * font scale setting, the header's desktop/mobile layout (switches at 992px),
 * the USP bar's breakpoint, and whether text wraps. Anything larger than the
 * truth opens a gap that page content scrolls through; anything smaller and the
 * next sticky element rides up under the stack. Measuring the bottom edge, not
 * a sum of heights, also stays right if the header is set to hide on scroll.
 *
 * The CSS carries starting values for first paint; this overwrites them with
 * the measured ones and keeps them current.
 */
(function () {
  var bar = document.querySelector('.usp-bar-section');
  var header = document.querySelector('.section-header');
  if (!bar && !header) return;

  var root = document.documentElement;
  var queued = false;
  var lastBar = -1;
  var lastStack = -1;

  function measure() {
    queued = false;
    var barRect = bar ? bar.getBoundingClientRect() : null;
    var headerRect = header ? header.getBoundingClientRect() : null;

    if (barRect) {
      var h = Math.round(barRect.height);
      if (h !== lastBar) {
        lastBar = h;
        root.style.setProperty('--usp-bar-h', h + 'px');
      }
    }

    var stack = Math.max(0, barRect ? barRect.bottom : 0, headerRect ? headerRect.bottom : 0);
    stack = Math.round(stack * 100) / 100;
    if (stack !== lastStack) {
      lastStack = stack;
      root.style.setProperty('--sticky-stack-h', stack + 'px');
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(measure);
  }

  measure();
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  window.addEventListener('scroll', schedule, { passive: true });

  /* Catches wrapping, font loading, the header's layout switch and any
     setting change in the editor. */
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(schedule);
    if (bar) ro.observe(bar);
    if (header) ro.observe(header);
  }
})();
